// ----------------------------------------------------------------------------
// Стартовый файл для скриптов аутентификации пользователя
// ----------------------------------------------------------------------------


import ttAuthGetCookie from "./modules/auth/tt-auth-get-cookie.js";
import ttAuthLogout from "./modules/auth/tt-auth-logout.js";
import ttAuth from "./modules/auth/tt-auth.js";
import auth_chooseOpenSocial from "./modules/auth/auth-choose-open-social.js";
import accept_agreement from "./modules/misc/accept-agreement.js";


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.oauth-btn:not(.js-listener-bound)').forEach(btn => {
        btn.addEventListener('click', (event) => auth_chooseOpenSocial(event));
        btn.classList.add('js-listener-bound');
    });

    if (window.ttUserIsLoggedIn) {
        if (window.location === ttAuthGetCookie('v_ttAuth_URL')) {

            if (ttAuthGetCookie('v_ttAuth_scrollTop') !== undefined) {
                jQtnk(window).scrollTop(ttAuthGetCookie("v_ttAuth_scrollTop"));

                const savedScroll = ttAuthGetCookie("v_ttAuth_scrollTop");
                if (savedScroll) {
                    window.scrollTo(0, parseInt(savedScroll, 10));
                }
            }

            const execCode = ttAuthGetCookie('v_ttAuth_Exec');

            if (execCode !== undefined) {
                eval(execCode); //TODO: потенциально нехорошо, переписать бы
                window.v_ttAuth_Exec = false;
            }

            document.cookie = "v_ttAuth_URL=; path=/; max-age=1; domain=" + document.domain.replace('guides.', '');
            document.cookie = "v_ttAuth_scrollTop=; path=/; max-age=1; domain=" + document.domain.replace('guides.', '');
            document.cookie = "v_ttAuth_Exec=; path=/; max-age=1; domain=" + document.domain.replace('guides.', '');
        }
    }

    const loginLinks = document.querySelectorAll('.js-login');
    loginLinks.forEach(loginLink => loginLink.addEventListener('click', (event) => ttAuth(event)));

    const logoutLinks = document.querySelectorAll('.js-logout');
    logoutLinks.forEach(logoutLink => logoutLink.addEventListener('click', (event) => ttAuthLogout(event)));

    document.querySelector('.js-agreement-accept')?.addEventListener('click', accept_agreement);
})